import * as React from 'react';
import { PersianMonthNames } from '../../../../enums/DateConsts';

import '../DatePicker.scss';

const Header = props => {
  return (
    <div className="datePickerHeader">
      <bdo dir="ltr" className="datePickerAction">
        <button type="button" onClick={props.nextMonth}>
          {' '}
          {'<'}{' '}
        </button>
        <span>
          <span onClick={props.onMonthClick}>{PersianMonthNames[props.mainDate.monthJalali - 1]} </span>
          <span onClick={props.onYearClick}>{+' ' + props.mainDate.yearJalali}</span>
        </span>
        <button type="button" onClick={props.previusMonth}>
          {' '}
          {'>'}{' '}
        </button>
      </bdo>
    </div>
  );
};

export default Header;
